import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ReactComponent as PDFIcon } from 'assets/images/document-formats/pdf.svg';
import styles from './index.module.scss';

export interface FileSelectionProps {
  file: File;
  className?: string;
}

const icons: any = {
  'application/pdf': PDFIcon,
};

function FileSelection(props: FileSelectionProps) {
  const { FileIcon, size } = useMemo(() => {
    return {
      FileIcon: icons[props.file.type],
      size: Math.round(props.file.size / 1024),
    };
  }, [props.file]);

  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.item}>
        <div className={styles.icon}>
          <FileIcon />
        </div>
        <div>
          <div className={styles.fileName}>{props.file.name}</div>
          <div className={styles.fileSize}>{size}Kb</div>
        </div>
      </div>
    </div>
  );
}

export default FileSelection;
